import {
  Button
} from "@material-ui/core";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import * as React from "react";
import {
  ISurveyEvaluationResponses,
} from "src/services";
import Component from "../../../components/Component";
import Modal, { IModalProps } from "../../../components/Modal";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import EmailValidator from "email-validator";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as format from "date-fns/format";
import "../../director/template-editor/report-style.css"
// import { ICoach } from "src/services";
// import { ISport } from "src/services";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import gritLogo from "src/assets/gritlogo.png";

const styles = (theme: Theme): Record<string, CSSProperties> => ({
  modal: {
    height: "80%",
    width: "80%",
  },
  summaryBox: {
    backgroundColor: "#efefef",
    border: "1px solid #424242",
    borderRadius: 4,
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
      1
    )}px ${theme.spacing(1)}px`,
  },
  text: {
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
});

/** Default team connectedness score items (label + score) when report has none */
const DEFAULT_TEAM_CONNECTEDNESS_SCORES = [
  { label: "Fear of mistakes" },
  { label: "Values my skills" },
  { label: "Encourages corrections" },
  { label: "Easy to ask for help" },
  { label: "Respects Input" },
  { label: "Encouraging Environment" },
  { label: "Welcomes Tough Issues"},
  { label: "Love Being on Team" },
];


/** Percent change helper based on current vs previous value */
function getPercentChange(current?: number | null, previous?: number | null): number | null {
  if (
    current == null ||
    previous == null ||
    isNaN(Number(current)) ||
    isNaN(Number(previous))
    //  ||
    // Number(previous) === 0
  ) {
    return null;
  }
  if (Number(previous) === 0){
    return 100;
  }else{
  return ((Number(current) - Number(previous)) / Number(previous)) * 100;
  }
 
}

function getPercentClass(change: number | null): string {
  if (change === null || change === 0 ) {return "small-blue-text";}
  if (change > 0) {return "small-green-text";}
  if (change < 0){ return "small-red-text";}
  return "small-blue-text";
}

function formatPercent(change: number | null): string {
  if (change === null) {return "0%";}
  if (change === 0) {return "no change";}
  const rounded = Math.round(change);
  const sign = rounded > 0 ? "+" : "";
  return `${sign}${rounded}%`;
}

/** Textarea that sets its height to match content (no scrollbar for content) */
// const AutoHeightTextarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = (props) => {
//   const ref = React.useRef<HTMLTextAreaElement>(null);
//   const adjustHeight = React.useCallback(() => {
//     const el = ref.current;
//     if (!el) {
//       return;
//     }
//     el.style.height = "auto";
//     el.style.height = el.scrollHeight + "px";
//   }, []);
//   React.useEffect(() => {
//     adjustHeight();
//   }, [adjustHeight, props.defaultValue]);
//   return (
//     <textarea
//       {...props}
//       ref={ref}
//       onInput={(e) => {
//         adjustHeight();
//         props.onInput?.(e);
//       }}
//       style={{ ...props.style, overflow: "hidden" }}
//     />
//   );
// };

interface IExtraProps {
  slug: string;
  // coach: ICoach;
  // sport: ISport;
  schoolId: number;
  isParentModal?: "true" | "false";
  schoolData: any
  ReportData: any
  refreshReports: () => Promise<void>;
  readOnly?: boolean;
}

type IBaseProps = IModalProps & IExtraProps;

type IProps = IBaseProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;


interface ISurveyResponsesModalState {
  loading?: true;
  index: number;
  surveyResponse?: ISurveyEvaluationResponses;
  showDeleteConfirmation?: true;
  isDeleting?: true;
  editableReportData?: any[];
  confirmGenerateReportOpen: boolean; // NEW

  emailModalOpen?: boolean;
  emailReportId?: number;
  emailValue?: string;
  emailSending?: boolean;
  emailError?: string;
  emailSuccess?: string;
  showLoader?: boolean;

  // Form data state
  formData?: {
    [key: string]: {
      highlights?: string[];
      overall_summary?: string;
      parentFeedback_appreciate?: string;
      parentFeedback_suggestions?: string;
      parentFeedback?: string[];
      coachSuggestions_0?: string;
      coachSuggestions_1?: string;
      team_connectedness_intro?: string;
      // Grit Leadership Action Plan editable fields
      grit_mid_season_actions?: string;
      grit_post_season_actions?: string;
      grit_season_end_reviews?: string;
      continuingDev?: string[];
      coachSuggestionsAD?: string;
      resources?: string[];
      chatgptChanges?: Record<string, string>;
    }
  }
}

// function cleanAndFormatHtml(input: string): string {
//       if (typeof input !== "string") {
//           return "";
//         }
//         const html = input
//           .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
//           .replace(/\*(.*?)\*/g, "<b>$1</b>");

//         const div = document.createElement("div");
//         div.innerHTML = html;

//         div.querySelectorAll("style").forEach(tag => tag.remove());
//         div.querySelectorAll("[style]").forEach(el => el.removeAttribute("style"));

//         return div.innerHTML;
//       }



function cleanAndFormatHtml_New(input: string): string {
  const html = input
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
    .replace(/\*(.*?)\*/g, "<b>$1</b>");

  const div = document.createElement("div");

  // If no HTML tags exist, wrap text in a span so styles can be applied
  if (!/<[a-z][\s\S]*>/i.test(html)) {
    div.innerHTML = `<span>${html}</span>`;
  } else {
    div.innerHTML = html;
  }

  div.querySelectorAll<HTMLElement>("*").forEach(el => {
    // el.style.color = "red";
    el.style.setProperty("font-family", '"Open Sans", sans-serif');

  });
  console.log("innerHtml:::::::", div.innerHTML);

  return div.innerHTML; // Now contains inline styles
}


export default withStyles(styles, { withTheme: true })(


  withAxios(
    class GenerateReportModal extends Component<
      IProps,
      ISurveyResponsesModalState
    > {
      public readonly state = this.buildState({
        index: 0,
        editableReportData: [],
        confirmGenerateReportOpen: false,// add this

        showLoader: false, // <-- add this
      });

      public componentDidMount() {
        // Process data immediately when component mounts
        if (this.props.ReportData && Array.isArray(this.props.ReportData) && this.props.ReportData.length > 0) {
          const editableReportData = this.props.ReportData.map((report: any) => {
            let parsedResponse = {};
            try {
              parsedResponse = report.chatgptChangeResposne
                ? typeof report.chatgptChangeResposne === 'string'
                  ? JSON.parse(report.chatgptChangeResposne.replace(/[\r\n]+/g, ''))
                  : report.chatgptChangeResposne
                : {};
            } catch (e) {
              console.warn("Invalid JSON in chatgptChangeResposne:", report.chatgptChangeResposne);
            }
            return {
              ...report,
              chatgptChangeResposne: parsedResponse,
            };
          });
          
          this.setState({ editableReportData }, () => {
            // Initialize formData after setting editableReportData
            this.initializeFormData();
          });
        }
      }

      public componentDidUpdate(prevProps: IProps) {
        console.log("componentDidUpdate - ReportData changed:", this.props.ReportData !== prevProps.ReportData);
        console.log("ReportData:", this.props.ReportData);
        if (this.props.ReportData !== prevProps.ReportData && this.props.ReportData) {
          console.log("Processing ReportData, length:", this.props.ReportData.length);
          const editableReportData = this.props.ReportData.map((report: any) => {
            let parsedResponse = {};


            try {
              parsedResponse = report.chatgptChangeResposne
                ? typeof report.chatgptChangeResposne === 'string'
                  ? JSON.parse(report.chatgptChangeResposne.replace(/[\r\n]+/g, ''))
                  : report.chatgptChangeResposne // already parsed
                : {};
            } catch (e) {
              console.warn("Invalid JSON in chatgptChangeResposne:", report.chatgptChangeResposne);
            }

            return {
              ...report,
              chatgptChangeResposne: parsedResponse,
            };
          });

          console.log("Setting editableReportData:", editableReportData);
          this.setState({ editableReportData }, () => {
            // Initialize formData after setting editableReportData
            this.initializeFormData();
          });
        }
      }

      

      public render() {
        const { open, classes, ReportData } = this.props;
        console.log("ReportData in GenerateReportModal:", ReportData, this.props);
        return (
          <Modal
            open={open}
            closeModal={this.props.closeModal}
            className={classes.modal}
          >
            {this.state?.showLoader && (
              <div
                style={{
                  position: "absolute", // absolute to modal
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.3)",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column"
                }}
              >
                <CircularProgress size={60} style={{ color: "#1976d2" }} />
                <div style={{ color: "#fff", fontSize: 22, marginTop: 24, textAlign: "center" }}>
                  Your report is being generated. It may take 3–5 minutes—thanks for your patience.
                  {/* Summary generation in progress, Do not refresh your screen. Please wait... */}
                </div>
              </div>
            )}
            {this.renderEditableReportData()}

          </Modal>
        );
      }

      // ---------------------- Private helpers ----------------------
      // private handleOpenEmailModal = (reportId: number) => {
      //   this.setState({ emailModalOpen: true, emailReportId: reportId, emailValue: "", emailError: "", emailSuccess: "" });
      // };
      //  private handleAutoNumbering = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      //   const textarea = e.currentTarget;
      //   const value = textarea.value;
      //   const cursorPosition = textarea.selectionStart;

      //   // Check if Enter key is pressed
      //   if (e.key === 'Enter') {
      //     e.preventDefault();
          
      //     // Get text before cursor
      //     const textBeforeCursor = value.substring(0, cursorPosition);
      //     const textAfterCursor = value.substring(cursorPosition);
          
      //     // Find all numbered items (e.g., "1. ", "2. ", etc.)
      //     const numberedPattern = /^(\d+)\.\s/gm;
      //     const matches = textBeforeCursor.match(numberedPattern);
          
      //     let nextNumber = 1;
      //     if (matches && matches.length > 0) {
      //       // Find the highest number
      //       const numbers = matches.map(match => parseInt(match.match(/\d+/)?.[0] || '0', 10));
      //       nextNumber = Math.max(...numbers) + 1;
      //     }
          
      //     // Insert new line with next number
      //     const newText = textBeforeCursor + `\n${nextNumber}. ` + textAfterCursor;
      //     textarea.value = newText;
          
      //     // Set cursor position after the inserted number
      //     const newCursorPosition = cursorPosition + `\n${nextNumber}. `.length;
      //     textarea.setSelectionRange(newCursorPosition, newCursorPosition);
          
      //     // Trigger input event to adjust height
      //     const inputEvent = new Event('input', { bubbles: true });
      //     textarea.dispatchEvent(inputEvent);
      //   }
      // };
      private handleCloseEmailModal = () => {
        this.setState({ emailModalOpen: false, emailReportId: undefined, emailValue: "", emailError: "", emailSuccess: "" });
      };

      private handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ emailValue: e.target.value, emailError: "", emailSuccess: "" });
      };

      private handleSendEmail = async () => {
        const { emailReportId, emailValue } = this.state as any;
        const isEmailValid = EmailValidator.validate(emailValue);
        if (!emailValue || !isEmailValid) {
          this.setState({ emailError: "Please enter a valid email address." });
          return;
        }
        this.setState({ emailSending: true, emailError: "", emailSuccess: "" });
        try {
          await this.buildPost<any, any>(
            this,
            "/reports/reportSend"
          )({ id: emailReportId, email: emailValue });
          this.setState({ emailSending: false, emailSuccess: "Email sent successfully!" });
          this.handleCloseEmailModal();
        } catch (error) {
          this.setState({ emailSending: false, emailError: "Failed to send email." });
        }
      };
      private GenerateReport = async () => {
        console.log(this.state, "update  the  state")
        console.log(this.props, "update  the  props")
        const currentUrl = window.location.href;

        let seasonTypes = "";
        const dashboardIndex = currentUrl.indexOf("/dashboard/");
        if (dashboardIndex !== -1) {
          const afterDashboard = currentUrl.substring(dashboardIndex + "/dashboard/".length);
          const parts = afterDashboard.split("/"); // Split by "/"
          seasonTypes = parts[0]; // This is the seasonType
        }

        // Get current year
        const currentYear = new Date().getFullYear();


        const { refreshReports } = this.props;
        this.setState({ showLoader: true }); // Show loader
        try {
          const notificationUpgraded = await this.buildPost<{ sportId: any, coachId: any, schoolId: any, type: any, sessionType: any, year: any }, any>(
            this, "/reports/reportad"
          )({
            schoolId: this.props?.schoolId,
            sportId: -1,
            coachId: -1,
            type: "ad",
            sessionType: seasonTypes,
            year: String(currentYear)

          });
          console.log("notificationUpgraded", notificationUpgraded);

          // Check if response has message property
          if ( notificationUpgraded.status === false) {
            alert(notificationUpgraded.contents);
            // Close modal after user clicks OK on alert
            if (this.props.closeModal) {
              this.props.closeModal();
            }
          }else{
            // Parent data refresh karein
          if (typeof refreshReports === "function") {
            await refreshReports();
          }
          }         
        } catch (error) {
          console.error("Error in notificationUpgraded:", error);
        } finally {
          this.setState({ showLoader: false }); // Hide loader
        }
      }

      // Handle form input change
      // private handleFormChange = (reportIdx: number, fieldName: string, value: any) => {
      //   const { formData } = this.state;
      //   const reportKey = `report_${reportIdx}`;

      //   this.setState({
      //     formData: {
      //       ...formData,
      //       [reportKey]: {
      //         ...formData?.[reportKey],
      //         [fieldName]: value,
      //       },
      //     },
      //   });
      // }

      // Handle print functionality - reusable method
      private handlePrint = (report: any) => {
        const content = document.getElementById(`reprotNewContainer`)?.innerHTML || '';
        const logoUrl = this.props?.schoolData?.gritLogo || gritLogo;
        const schoolName = this.props?.schoolData?.name || this.props.schoolData?.schoolName || '';
        const schoolLogo = this.props?.schoolData?.logo1 || '';
       const seasonLabel = report.season || '';
        console.log("seasonLabel", seasonLabel);
        // Extract header HTML
        const headerLeft = `
          <p class="subtitle">Athletic Program Snapshot - ${seasonLabel}</p>
          <h1>${schoolName}</h1>
        `;
        
        const headerRight = schoolLogo ? `
          <img src="${schoolLogo}" alt="School Logo" style="width: 50px; height: 50px;" />
        ` : '';

        const printWindow = window.open('', '_blank', 'width=1600,height=1200');

        if (printWindow) {
          // Grab all CSS <link> and <style> from current page
          const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
            .map(style => style.outerHTML)
            .join('\n');

          printWindow.document.write(`
          <html>
            <head>
             
              ${styles}
              
        <style>
            body {
                    padding: 0 0 20px 0;
                    color: #000;
                  }

                  .page-break {
                    page-break-after: always;
                  }
                @media print {
                 
                  body {
                      -webkit-print-color-adjust: exact;
                          print-color-adjust: exact;
                          margin: 0;
                          padding-top: 0 !important;
                          padding-bottom: 20px !important;
                          overflow: visible !important;
                          height: auto !important;
                 }
                 html {
                   overflow: visible !important;
                   height: auto !important;
                 }
                  
                 .print-content-wrapper {
                   padding-top: 85px !important;
                   padding-bottom: 20px !important;
                 }
                  
                 .print-content-wrapper .report-header {
                   display: none !important;
                 }
                 .three-points {
                   padding: 10px 10px !important;
                 }
                .three-points-container > *:first-child {
                  padding-top:20px;
                }
                 .print-content-wrapper > *:first-child {
                   margin-top: 0 !important;
                 }
                 
                 /* Add top padding to content sections to account for fixed header */
                 .print-content-wrapper .top-section {
                   padding-top: 0 !important;
                   margin-top: 0 !important;
                 }
                  
                 /* Ensure sections that start on new pages have proper spacing for header */
                 .print-content-wrapper .main-summary,
                 .print-content-wrapper .report-card,
                 .print-content-wrapper .whiteBox,
                 .print-content-wrapper .card {
                   break-inside: avoid;
                   page-break-inside: avoid;
                   /* Add top margin when these sections start on a new page */
                   margin-top: 0 !important;
                 }
                 /* Conclusion section - add 100px space below header for 3rd page print */
                 .print-content-wrapper .conclusion {
                   break-inside: avoid !important;
                   page-break-inside: avoid !important;
                   margin-top: 0 !important;
                   padding-top: 100px !important;
                   page-break-before: auto !important;
                   break-before: auto !important;
                 }
                   .print-content-wrapper .main-summary {
                   align-items: stretch !important;
                   display: grid !important;
                   grid-template-columns: 2.4fr 1fr !important;
                   gap: 10px !important;
                   align-content: start !important;
                   align-items: start !important;
                   margin-top: 0px !important;
                  }
                  
                  .print-content-wrapper .main-summary > .card {
                   align-self: stretch !important;
                   margin-top: 0 !important;
                   margin-bottom: 0 !important;
                   padding: 15px !important;
                   display: flex !important;
                   flex-direction: column !important;
                   vertical-align: top !important;
                   position: relative !important;
                   top: 0 !important;
                   height: 100% !important;
                  }
                  
                  .print-content-wrapper .main-summary .card:first-child,
                  .print-content-wrapper .main-summary .card.summary {
                   margin-top: 0 !important;
                   padding-top: 15px !important;
                  }
             
                  .print-content-wrapper .main-summary .card h5 {
                   margin: 0 0 14px 0 !important;
                   padding: 0 !important;
                   line-height: 1.2 !important;
                           
                  }
                  
                  .print-content-wrapper .main-summary .card.summary h5 {
                   margin: 0 0 14px 0 !important;
                   padding: 0 !important;
                   line-height: 1.2 !important;
               
                  }
                  
                  .print-content-wrapper .main-summary .list {
                   margin: 0 !important;
                   padding: 0 !important;
                  }
                  
                  .print-content-wrapper .main-summary .card.summary > *:not(h5) {
                   margin-top: 0 !important;
                   padding-top: 0 !important;
                  }
                  .print-content-wrapper .continue-development {
                   padding-top: 80px !important;
                   margin-top: 20px !important;
                   border: none !important;
                 }
                 /* Only Parent Feedback Summary container - remove top space for print */
               
                 .print-content-wrapper .connectedness .tc-header span {
                   color:rgba(0, 0, 0, 1) !important;
                   font-weight: bold !important;
                  }
           
                 .print-content-wrapper .continue-development .card.pad:first-child {
                   margin-right: 10px !important;
              
                 }
                 .print-content-wrapper .continue-development .card.pad h5 {
                   margin-bottom: 15px !important;
                 }
                 .print-content-wrapper .continue-development .card.pad .resource-container {
                   margin-top: 0 !important;
                 }
                 /* Resources for Growth - title visible, no gap between heading and boxes (print only) */
                 .print-content-wrapper .continue-development .resources-for-growth-heading-wrap {
                   display: block !important;
                   margin-bottom: 15px !important;
                   padding-top: 0 !important;
                   padding-bottom: 0 !important;
                   min-height: 0 !important;
                   overflow: visible !important;
                   page-break-after: avoid !important;
                 }
                 .print-content-wrapper .continue-development .resources-for-growth-heading-wrap h5 {
                   display: block !important;
                   visibility: visible !important;
                   margin: 0 !important;
                   padding: 0 !important;
                   width: 100% !important;
                   position: relative !important;
                   z-index: 1 !important;
                   page-break-after: avoid !important;
                 }
                 .print-content-wrapper .continue-development .card.pad .resource-container {
                   margin-top: 0 !important;
                   position: relative !important;
                   z-index: 0 !important;
                 }
                 /* Resources for Growth - match normal (screen) CSS 100% for print only */

                 
            
                 
                 .print-content-wrapper .continue-development .card.pad .resource-container .whiteBox p {
                   font-size: 14px !important;
                   line-height: 1.4 !important;
                   color: rgba(0, 0, 0, 1) !important;
                  
                   margin: 0 !important;
                   padding: 0 !important;
                   white-space: pre-wrap !important;
                   word-wrap: break-word !important;
                   border: none !important;
                 }
          
                /* Add spacing for content that starts on a new page after page break */
                .page-break {
                  display: block;
                  margin-top: 0 !important;
                  margin-bottom: 0 !important;
                  padding-top: 80px !important;
                }
                
                /* Ensure content after explicit page breaks has space for header */
                .page-break + * {
                  margin-top: 0 !important;
                  padding-top: 0 !important;
                }
                
                /* Add top margin to major sections to account for header on new pages */
                .print-content-wrapper .main-summary:not(:first-child){
                   margin-top: 10px !important;
                 }
                .print-content-wrapper .report-card:not(:first-child),
                .print-content-wrapper .whiteBox:not(:first-child),
                .print-content-wrapper .card:not(:first-child) {
                  margin-top: 20px !important;
                }
                
                 .print-header {
                    position: fixed !important;
                    top: -8px !important;
                    left: 0 !important;
                    right: 0 !important;
                    width: 100% !important;
                    // background-color:rgba(185, 217, 235, 0.2) !important;
                    background-color:#f0f7fb !important;

                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                    z-index: 1000 !important;
                    display: flex !important;
                    justify-content: space-between !important;
                    align-items: center !important;
                     padding: 10px 20px 10px 20px !important;
                    border-bottom: 10px solid #fff !important;
                  }
                  .print-header {
                   margin-bottom: 10px!important;
                  }
                  .print-header .header-left {
                    display: flex;
                    flex-direction: column; 
                 
                  }
                    .main-summary .card h5,.summry-bottom h5,
                     .header-left .title,.surveyed-score .stat strong,.main-summary .item h4 {
                       font-family: Lato, sans-serif !important;
                     }
                  .print-header .header-left h1 {
                    font-family: Lato, sans-serif !important;
                  }
                  .print-header .header-left p {
                    font-weight: 500;
                    margin-bottom: 6px;
                    text-transform: capitalize;
                    margin: 0 0 6px 0;
                    font-size: 14px;
                    display: block !important;
                    visibility: visible !important;
                    opacity: 1 !important;
                  }
                  .print-header .header-left p.subtitle {
                    display: block !important;
                    visibility: visible !important;
                  }
              
                   .header-left .title,
                  .print-header .header-left h1 {
                    margin: 0;
                    width: 100%;
                     font-weight: 700 !important;
                   }
                  .print-header .header-left .title {
                    font-size:32px !important;
                  }
                  .print-header .header-right img {
                    width: 50px;
                    height: 50px;
                  }
                  
                  .report-section {
                    break-inside: avoid;
                    page-break-inside: avoid;
                  }
                  
                  .report-section:first-child {
                    margin-top: 0 !important;
                  }
                  
                  .page-break {
                    display: block;
                    height: 0 !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    border: none !important;
                    page-break-after: always;
                    break-after: page;
                    background: transparent !important;
                  }
                  
                  #reprotNewContainer {
                    padding-bottom: 20px;
                  }
                  
                  .footer-logo {
                    position: fixed !important;
                    bottom: -2px !important;
                    left: 0 !important;
                    right: 0 !important;
                    width: 100% !important;
                    text-align: center !important;
                    z-index: 10000 !important;
                    display: flex !important;
                    justify-content: center !important;
                    align-items: center !important;
                    background: #fff !important;
                    border: 10px solid #fff !important;
                    height: 45px;
                  }
                  
                  .footer-logo img {
                    height: 30px !important;
                    width: auto !important;
                    max-width: 100px !important;
                    margin: 0 auto !important;
                    display: block !important;
                  }
                  
                  @page {
                    margin-top: 90px;
                    margin-bottom: 60px;
                    size: auto;
                  }
                  
                  @page :first {
                    margin-top: 90px;
                    margin-bottom: 60px;
                  }
                  
                  /* Ensure all pages have consistent top margin for header */
                  @page :left,
                  @page :right {
                    margin-top: 100px;
                    margin-bottom: 60px;
                  }
                  
                  /* Ensure content sections respect page breaks */
                  .print-content-wrapper > * {
                    break-inside: avoid;
                    page-break-inside: avoid;
                  }
                  /* Prevent extra blank page: last element must not force a new page */
                  .print-content-wrapper > *:last-child {
                    page-break-after: auto !important;
                    break-after: auto !important;
                  }
                  
                                
                                              
                  /* Resources for Growth - CSS Grid layout for print page */
                  /* General rule for card.pad.summary h5 - Resources for Growth has specific rule below */
                  .print-content-wrapper .card.pad.summary h5 {
                    margin-bottom: 20px !important;
                    padding-bottom: 10px !important;
                    display: block !important;
                    clear: both !important;
                    position: relative !important;
                    z-index: 10 !important;
                    width: 100% !important;
                    max-width: 100% !important;
                    box-sizing: border-box !important;
                    page-break-after: avoid !important;
                    font-size: 18px !important;
                    font-weight: 600 !important;
                    color: #000 !important;
                
                  }
                  .print-content-wrapper .card.pad.summary {
                    width: 100% !important;
                    max-width: 100% !important;
                    box-sizing: border-box !important;
                  }
                        
                                    
                    .overallInfo p {
                    text-align:justify;
                  }  
                 
                  .print-content-wrapper .summry-bottom {
                    display: grid !important;
                    grid-template-columns: 1fr 2.4fr !important;
                    align-items: stretch !important;
                    align-content: stretch !important;
                    margin-top: 0px !important;
                    padding-top: 10px !important;
                    gap: 15px !important;
                  }
                    .print-content-wrapper .summry-bottom > div:first-child {
                        margin-right: 10px !important;
                      }
                       .print-content-wrapper .summry-bottom > .card:first-child {
                      margin-top: 0 !important;
                      padding-top: 0 !important; 
                    }
                     .print-content-wrapper .summry-bottom h5:first-child {
                       margin-bottom:0px!important;
                     }
                  /* Parent Feedback Summary - 10px space below title, above "Parents Appreciate" box (print only) */
                  .print-content-wrapper .summry-bottom > .card:first-child h5 {
                     margin-bottom: 0 !important;
                     padding-bottom: 0 !important;
                     position:relative !important;
                     bottom:-10px !important;
                  }
                  .print-content-wrapper .summry-bottom > .card:first-child {
                     gap: 0px !important;
                  }
                  /* Both cards equal height, 15px gap between children */
                  .print-content-wrapper .summry-bottom .card {
                    display: flex !important;
                    flex-direction: column !important;
                    height: 100% !important;
                    align-self: stretch !important;
                    gap: 15px !important;
                  }
                  .print-content-wrapper .summry-bottom > .card:not(:first-child) {
                    gap: 0 !important;
                  }
                    .print-content-wrapper .summry-bottom .card h5 {
                     padding-top: 10px !important;
                     margin-top: 0 !important;
                     margin-bottom: 0 !important;
                     padding-bottom: 0 !important;
                     display: block !important;
                     width: 100% !important;
                     text-align: left !important;
                     font-weight: 600 !important;
                     line-height: 1.2 !important;
              
                    }
                 
                    .print-content-wrapper .summry-bottom .tc-header {
                     display: flex !important;
                     justify-content: space-between !important;
                     align-items: start !important;
                     width: 100% !important;
                     margin-bottom: 15px !important;
                     padding-top: 0px !important;
                    }
                    .print-content-wrapper .summry-bottom .tc-header h5 {
                     margin: 0 !important;
                     padding: 0 !important;
                     display: inline-block !important;
                     width: auto !important;
                     text-align: left !important;
                     font-weight: 600 !important;
                 
                     line-height: 1.4 !important;
                    }
                    .print-content-wrapper .summry-bottom .tc-header span {
                     margin: 0 !important;
                     padding: 0 !important;
                     display: inline-block !important;
                     font-size: 12px !important;
                     text-align: right !important;
                     color: #666 !important;
                    }
                  .print-content-wrapper .summry-bottom .card .whiteBox {
                    margin-bottom: 0 !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    display: flex !important;
                    flex-direction: column !important;
                  }
                  .summry-bottom .whiteBox:last-child {
                    margin-bottom: 0 !important;
                  }
                     .summry-bottom .card:last-child {
                     position: static !important;       
                      top: auto !important;
                      align-self: start !important;
                      margin-top: 0 !important;
                      height: auto !important;
                    }
                                 
                 
                  .continue-development .whiteBox {
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                    display: flex !important;
                    flex-direction: column !important;
                  }
                  .continue-development .whiteBox:last-child {
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                  }
          
                
                  .print-content-wrapper .continue-development .whiteBox {
                   margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                    border: none !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                  }
               
                    .print-content-wrapper .continue-development .whiteBox.coachsuggestion {
                    position: relative !important;
                    top: -12px !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                    display: block !important;
                    padding-bottom:10px !important;
                  }
                  .print-content-wrapper .continue-development .whiteBox.coachsuggestion p {
                    line-height: 1.2 !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                    white-space: pre-wrap !important;
                    word-wrap: break-word !important;
                  }
                               
                      .three-points h6 {
                       margin-bottom: 5px !important;
                        font-size: 14px !important;
                    }
                        .scores .score p,
                     .surveyed-score .stat span {
                       font-size: 11px !important;
                     }
                  
                    .conclusion-infotext p {
                         line-height: 14px;
                          font-size: 10px !important;
                    }
                    .summry-bottom .overallOuter {
                      grid-template-columns: 2.5fr 1fr !important;
                      align-items: flex-start !important;
                      margin-top: 15px !important;
                    }
                    /* Conclusion section - 100px space below header for print (especially 3rd page) */
                    .print-content-wrapper .conclusion {
                      margin-top: 0 !important;
                      padding-top: 100px !important;
                    }
                    .print-content-wrapper .conclusion .card {
                      margin-top: 0 !important;
                      padding-top: 0 !important;
                    }
                    .print-content-wrapper .conclusion .conclusion-infotext {
                      margin-top: 0 !important;
                      padding-top: 0 !important;
                    }                                 
                    .print-content-wrapper .summry-bottom  .overall {
                       padding:10px 5px !important;
                    }
                    .print-content-wrapper .summry-bottom .overallOuter {
                      display: grid !important;
                      align-items: flex-start !important;
                      margin-top: 20px !important;
                      clear: both !important;
                    }
                  
                    .conclusion .timeline:before {
                          top: 110px;
                    }
                    .scores .score {
                      padding: 5px 5px !important;
                    }
              
                    /* ===============================
                        TEAM CONNECTEDNESS – PRINT FIX
                        =============================== */
                      .print-content-wrapper .summry-bottom .connectedness {
                        display: block !important;
                        width: 100% !important;
                        overflow: visible !important;
                        break-inside: avoid !important;
                        page-break-inside: avoid !important;
                        margin-bottom: 0 !important;
                      }

                      /* Scores grid alignment */
                      .print-content-wrapper .summry-bottom .connectedness .scores {
                        display: grid !important;
                        grid-template-columns: repeat(4, 1fr) !important;
                        gap: 20px !important;
                        align-items: flex-start !important;
                        align-content: start !important;
                        margin-bottom: 0 !important;
                        break-inside: avoid !important;
                      }

                      /* Individual score card - equal size for all blue boxes */
                      .print-content-wrapper .summry-bottom .connectedness .score {
                        display: flex !important;
                        flex-direction: column !important;
                        align-items: center !important;
                        justify-content: flex-start !important;
                        width: 100% !important;
                        min-width: 0 !important;
                        max-width: 100% !important;
                        padding:10px !important;
                        height: auto !important;
                        min-height: 90px !important;
                        break-inside: avoid !important;
                        page-break-inside: avoid !important;
                      }

                      /* Ring size stability - equal size for all rings */
                      .print-content-wrapper .summry-bottom .connectedness .score .ring {
                        width: 80px !important;
                        height: 80px !important;
                        min-width: 80px !important;
                        min-height: 80px !important;
                        max-width: 80px !important;
                        max-height: 80px !important;
                        flex-shrink: 0 !important;
                        margin-bottom: 4px !important;
                      }

                      /* Score text */
                      .print-content-wrapper .summry-bottom .connectedness .score p {
                        font-size: 9px !important;
                        line-height: 1.2 !important;
                        text-align: center !important;
                        margin: 0 !important;
                      }

                      /* Overall connectedness section - 20px space above "Connectedness and belonging" text (print only) */
                      .print-content-wrapper .summry-bottom .overallOuter {
                        display: grid !important;
                        grid-template-columns: 2.5fr 1fr !important;
                        align-items: stretch !important;
                        gap: 10px !important;
                        margin-top: 20px !important;
                        break-inside: avoid !important;
                        page-break-inside: avoid !important;
                      }
                      /* Overall blue box - equal height with text */
                      .print-content-wrapper .summry-bottom .overallOuter .overall {
                        height: 100% !important;
                        min-height: 100% !important;
                        display: flex !important;
                        flex-direction: column !important;
                        justify-content: center !important;
                        align-items: center !important;
                        padding: 10px 5px !important;
                        box-sizing: border-box !important;
                      }
                      /* Resources for Growth - Additional print fixes */
                     
                    
                     .print-content-wrapper .resource-container .whiteBox p {
                       line-height: 1.6 !important;
                       padding-bottom: 0 !important;
                       overflow: visible !important;
                       width: 100% !important;
                       max-width: 100% !important;
                       height: auto !important;
                       min-height: auto !important;
                       max-height: none !important;
                       word-wrap: break-word !important;
                       word-break: break-word !important;
                       font-size: 12px !important;
                       color: #000 !important;
                       white-space: pre-wrap !important;
                       font-style: italic !important;
                     }
                      .print-content-wrapper .resource-container .whiteBox h4 {
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        margin: 0 0 12px 0 !important;
                        margin-top: 0 !important;
                        padding: 0px !important;
                        width: 100% !important;
                        max-width: 100% !important;
                        position: relative !important;
                         background: #ffffff !important;
                      background-color: #ffffff !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                        color: #000 !important;
                        page-break-after: avoid !important;
                      }
                     
                   
                      /* Overall score card stability - equal height */
                      .print-content-wrapper .summry-bottom .overallOuter .card {
                        position: relative !important;
                        top: 0 !important;
                        align-self: stretch !important;
                        height: 100% !important;
                        min-height: 100% !important;
                        display: flex !important;
                        flex-direction: column !important;
                      }

                      /* Prevent absolute / floating issues in print */
                      .print-content-wrapper .connectedness *,
                      .print-content-wrapper .overallOuter * {
                        position: static !important;
                      }
                      .summary p, .summry-bottom p, .main-summary .item p {
                        font-size: 13px !important;
                        line-height: 1.2;
                      }
                         /* Resources for Growth - equal height four boxes, full content visible */
                         .print-content-wrapper .continue-development .resource-container .whiteBox.resources-growth-box,
                         .print-content-wrapper .continue-development .card.pad .resource-container .whiteBox.resources-growth-box,
                         .print-content-wrapper .resource-container .whiteBox.resources-growth-box {
                      -webkit-print-color-adjust: exact !important;
                      print-color-adjust: exact !important;
                      border: none !important;
                      display: flex !important;
                      flex-direction: column !important;
                      overflow: visible !important;
                      padding: 0 !important;
                      background: transparent !important;
                     }
                     .print-content-wrapper .connectedness {
                         margin-top:-10px !important;
                         position:static !important;
                          top:-16px !important;
                         }
                         .connectedness .tc-header {
                          padding-bottom:10px !important;
                         }
               
              
                         .print-content-wrapper .resource-container {
                          display: grid !important;
                          grid-template-columns: repeat(2, 1fr) !important;
                          grid-auto-rows: auto !important;
                          align-items: stretch !important;
                          justify-items: stretch !important;
                          position: relative !important;
                          gap: 15px !important;
                          margin-top: 15px !important;
                          clear: both !important;
                          border: none !important;
                          width: 100% !important;
                      }
                      /* No gap between "Resources for Growth" title and the 4 boxes - print only */
                 .print-content-wrapper .continue-development .resources-for-growth-heading-wrap {
                   margin-top:-5px !important;
                    margin-bottom: 25px !important;
                 }
                 /* Resources for Growth: proper text alignment and padding for print only */
                        .print-content-wrapper .continue-development .card.pad .resource-container .whiteBox.resources-growth-box p:not(.title-para) {
                          margin: 0 !important;
                          padding: 0 !important;
                          text-align: left !important;
                          width: 100% !important;
                        }
                           .print-content-wrapper .resource-container .whiteBox.resources-growth-box p.title-para {
                         font-size:18px !important;
                         padding-bottom:10px !important;
                         margin-bottom:10px !important;
                         font-style:normal !important;
                         font-weight:bold !important;
                         font-family: Lato, sans-serif!important;
                         text-align: center !important;
                         margin-top: 0 !important;
                         margin-left: 0 !important;
                         margin-right: 0 !important;
                         padding-left: 0 !important;
                         padding-right: 0 !important;
                         padding-top: 0 !important;
                         width: 100% !important;
                        }
                        .print-content-wrapper .resource-container .whiteBox.resources-growth-box .printclass {
                         position: relative !important;
                         top: 0 !important;
                         left: 0 !important;
                         right: 0 !important;
                         width: 100% !important;
                         max-width: 100% !important;
                         box-sizing: border-box !important;
                         display: block !important;
                         height: auto !important;
                         min-height: auto !important;
                         max-height: none !important;
                         overflow: visible !important;
                         padding: 15px 15px 15px 15px !important;
                         margin: 0 !important;
                         background: #fff !important;
                         border-radius: 8px !important;
                         -webkit-print-color-adjust: exact !important;
                         print-color-adjust: exact !important;
                         border: none !important;
                         text-align: left !important;
                         vertical-align: top !important;
                         }
                        .print-content-wrapper .resource-container .whiteBox.resources-growth-box .printclass p:not(.title-para) {
                         height: auto !important;
                         min-height: auto !important;
                         max-height: none !important;
                         overflow: visible !important;
                         display: block !important;
                         text-align: left !important;
                         width: 100% !important;
                         margin: 0 !important;
                         padding: 0 !important;
                         line-height: 1.5 !important;
                         word-wrap: break-word !important;
                         word-break: break-word !important;
                         white-space: pre-wrap !important;
                         }
                       
                      body .print-content-wrapper .summry-bottom .card.pad h5 {
                          font-size: 22px !important;
                        }
                          .conclusion h5:first-child {
                            margin-bottom:0 !important;
                            line-height:1.2;
                          }
                       .summry-bottom .whiteBox h4 {
                         text-align:center !important;
                         font-weight:normal;
                         margin-bottom:4px !important;
                         font-size:16px !important;
                       } 
                 
                         .print-content-wrapper .continue-development {
                         grid-template-columns: 1fr 1fr !important;
                          gap: 3px !important;
                    
                        } 
                          .print-content-wrapper .continue-development .card.pad:first-child h5 {
                            padding-top:15px !important;
                          }
                           .print-content-wrapper .continue-development .card.pad:last-child {
                            position:relative;
                            top:0px  !important;
                           }
                          .print-content-wrapper .action-plan-wrapper h5 {
                            margin-bottom: 5px !important;
                          }
                         .print-content-wrapper .continue-development .card.pad:first-child {
                           border-radius:8px !important;
                        }     

                  body {
                    overflow: visible !important;
                    height: auto !important;
                  }
                  html {
                    overflow: visible !important;
                    height: auto !important;
                  }
                }
             
              </style>
            </head>
            <body>
              <div class="print-header">
                <div class="header-left">
                  ${headerLeft}
                </div>
                ${headerRight ? `<div class="header-right">${headerRight}</div>` : ''}
              </div>
              <div class="print-content-wrapper">
                ${content}
              </div>
              <div class="footer-logo">
                <img src="${logoUrl}" alt="Grit Leadership Logo" />
              </div>
              <script>
                (function() {
                  if (typeof Element.prototype.closest !== 'function') {
                    Element.prototype.closest = function(s) {
                      var el = this; while (el) {
                        if (el.nodeType === 1 && (el.matches ? el.matches(s) : el.msMatchesSelector(s))) return el;
                        el = el.parentElement;
                      }
                      return null;
                    };
                  }
                  function adjustResourceBoxes() {
                    var whiteBoxes = document.querySelectorAll('.resource-container .whiteBox');
                    for (var i = 0; i < whiteBoxes.length; i++) {
                      var box = whiteBoxes[i];
                      if (box && !(box.closest && box.closest('.continue-development'))) {
                        box.style.setProperty('height', 'auto', 'important');
                        box.style.setProperty('min-height', 'auto', 'important');
                        box.style.setProperty('max-height', 'none', 'important');
                        box.style.setProperty('overflow', 'visible', 'important');
                      }
                    }
                  }
                  function adjustGrowthBoxesEqualHeight() {
                    var containers = document.querySelectorAll('.continue-development .resource-container');
                    for (var c = 0; c < containers.length; c++) {
                      var container = containers[c];
                      var boxes = container.querySelectorAll('.whiteBox');
                      if (boxes.length === 0) continue;
                      var maxH = 120;
                      for (var b = 0; b < boxes.length; b++) {
                        var h = boxes[b].scrollHeight || boxes[b].offsetHeight || 0;
                        if (h > maxH) maxH = h;
                      }
                      for (var b = 0; b < boxes.length; b++) {
                        var w = boxes[b];
                        w.style.setProperty('min-height', maxH + 'px', 'important');
                        w.style.setProperty('height', 'auto', 'important');
                        w.style.setProperty('overflow', 'visible', 'important');
                        w.style.setProperty('max-height', 'none', 'important');
                      }
                    }
                  }
                  adjustResourceBoxes();
                  adjustGrowthBoxesEqualHeight();
                  if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', function() { adjustResourceBoxes(); adjustGrowthBoxesEqualHeight(); });
                  }
                  window.addEventListener('load', function() {
                    adjustResourceBoxes();
                    adjustGrowthBoxesEqualHeight();
                  });
                  setTimeout(function() { adjustResourceBoxes(); adjustGrowthBoxesEqualHeight(); }, 50);
                  setTimeout(function() { adjustResourceBoxes(); adjustGrowthBoxesEqualHeight(); }, 100);
                  setTimeout(adjustGrowthBoxesEqualHeight, 200);
                  setTimeout(adjustGrowthBoxesEqualHeight, 400);
                })();
              </script>
            </body>
          </html>
        `);

          printWindow.document.close();
          printWindow.focus();

          // Adjust print layout
          const adjustPrintTextareas = () => {
            // Resource containers: grid layout (Resources for Growth uses stretch + JS equal min-height)
            const resourceContainers = printWindow.document.querySelectorAll('.resource-container');
            resourceContainers.forEach((container: any) => {
              const isGrowth = container.closest('.continue-development');
              container.style.setProperty('display', 'grid', 'important');
              container.style.setProperty('grid-template-columns', 'repeat(2, 1fr)', 'important');
              container.style.setProperty('grid-auto-rows', 'auto', 'important');
              container.style.setProperty('gap', '10px', 'important');
              container.style.setProperty('align-items', isGrowth ? 'stretch' : 'start', 'important');
              container.style.setProperty('justify-items', 'stretch', 'important');
              container.style.setProperty('width', '100%', 'important');
              container.style.setProperty('margin-top', isGrowth ? '0' : '15px', 'important');
              container.style.setProperty('clear', 'both', 'important');
            });
            
            // Fix h5 - Resources for Growth (no space between heading and boxes)
            const resourceSectionTitles = printWindow.document.querySelectorAll('.continue-development .card.pad.summary h5, .card.pad.summary h5, .continue-development .resources-for-growth-heading-wrap h5');
            resourceSectionTitles.forEach((h5: any) => {
              if (h5 && h5.textContent && h5.textContent.trim() === 'Resources for Growth') {
                h5.style.setProperty('margin', '0', 'important');
                h5.style.setProperty('margin-bottom', '0', 'important');
                h5.style.setProperty('padding', '0', 'important');
                h5.style.setProperty('white-space', 'nowrap', 'important');
              }
            });
            // Resources for Growth: equal-height four white boxes (cross-platform: force reflow then measure)
            const growthContainers = printWindow.document.querySelectorAll('.continue-development .resource-container');
            for (const container of Array.from(growthContainers) as HTMLElement[]) {
              const boxes = container.querySelectorAll('.whiteBox');
              if (!boxes || boxes.length === 0) {
                continue;
              }
              let maxHeight = 120;
              for (const el of Array.from(boxes) as HTMLElement[]) {
                const h = el.scrollHeight || el.offsetHeight || 0;
                if (h > maxHeight) {
                  maxHeight = h;
                }
              }
              for (const whiteBox of Array.from(boxes) as HTMLElement[]) {
                if (whiteBox) {
                  whiteBox.style.setProperty('min-height', maxHeight + 'px', 'important');
                  whiteBox.style.setProperty('height', 'auto', 'important');
                  whiteBox.style.setProperty('overflow', 'visible', 'important');
                  whiteBox.style.setProperty('max-height', 'none', 'important');
                }
              }
            }
            // Other resource whiteBoxes (outside continue-development) - expand to content
            const otherResourceBoxes = printWindow.document.querySelectorAll('.resource-container .whiteBox');
            otherResourceBoxes.forEach((whiteBox: any) => {
              if (whiteBox && !whiteBox.closest('.continue-development')) {
                whiteBox.style.setProperty('height', 'auto', 'important');
                whiteBox.style.setProperty('overflow', 'visible', 'important');
              }
            });
            
            // Fix Parent Feedback Summary and Team Connectedness - equal height columns
            const summryBottom = printWindow.document.querySelector('.summry-bottom') as any;
            if (summryBottom) {
              summryBottom.style.setProperty('display', 'grid', 'important');
              summryBottom.style.setProperty('grid-template-columns', '1fr 1.7fr', 'important');
              summryBottom.style.setProperty('align-items', 'stretch', 'important');
              summryBottom.style.setProperty('align-content', 'stretch', 'important');
              summryBottom.style.setProperty('gap', '0', 'important');
            }
            
            // Make both cards equal height
            const summryBottomCards = printWindow.document.querySelectorAll('.summry-bottom .card');
            summryBottomCards.forEach((card: any) => {
              if (card) {
                card.style.setProperty('display', 'flex', 'important');
                card.style.setProperty('flex-direction', 'column', 'important');
                card.style.setProperty('height', '100%', 'important');
                card.style.setProperty('align-self', 'stretch', 'important');
              }
            });
            
            // Fix Parent Feedback Summary and Team Connectedness titles alignment
            const summryBottomH5s = printWindow.document.querySelectorAll('.summry-bottom .card h5');
            summryBottomH5s.forEach((h5: any) => {
              if (h5) {
                h5.style.setProperty('padding-top', '10px', 'important');
                h5.style.setProperty('margin-top', '0', 'important');
                h5.style.setProperty('margin-bottom', '0', 'important');
                h5.style.setProperty('padding-bottom', '0', 'important');
                h5.style.setProperty('display', 'block', 'important');
                h5.style.setProperty('width', '100%', 'important');
                h5.style.setProperty('text-align', 'left', 'important');
                h5.style.setProperty('font-weight', '600', 'important');
                h5.style.setProperty('font-size', '20px', 'important');
                h5.style.setProperty('line-height', '1.4', 'important');
              }
            });
            
            // Fix Team Connectedness header layout
            const tcHeaders = printWindow.document.querySelectorAll('.summry-bottom .tc-header');
            tcHeaders.forEach((header: any) => {
              if (header) {
                header.style.setProperty('display', 'flex', 'important');
                header.style.setProperty('justify-content', 'space-between', 'important');
                header.style.setProperty('align-items', 'baseline', 'important');
                header.style.setProperty('width', '100%', 'important');
                header.style.setProperty('margin-bottom', '0', 'important');
                header.style.setProperty('padding-top', '10px', 'important');
                
                const h5 = header.querySelector('h5');
                if (h5) {
                  h5.style.setProperty('margin', '0', 'important');
                  h5.style.setProperty('padding', '0', 'important');
                  h5.style.setProperty('display', 'inline-block', 'important');
                  h5.style.setProperty('width', 'auto', 'important');
                  h5.style.setProperty('text-align', 'left', 'important');
                }
                
                const span = header.querySelector('span');
                if (span) {
                  span.style.setProperty('margin', '0', 'important');
                  span.style.setProperty('padding', '0', 'important');
                  span.style.setProperty('display', 'inline-block', 'important');
                  span.style.setProperty('font-size', '12px', 'important');
                  span.style.setProperty('text-align', 'right', 'important');
                  span.style.setProperty('color', '#666', 'important');
                }
              }
            });
            
            // Adjust Parent Feedback Summary boxes (summry-bottom .whiteBox) to match content height
            const parentFeedbackBoxes = printWindow.document.querySelectorAll('.summry-bottom .whiteBox');
            parentFeedbackBoxes.forEach((box: any) => {
              if (box) {
                // Reset box height
                box.style.setProperty('height', 'auto', 'important');
                box.style.setProperty('min-height', 'auto', 'important');
                box.style.setProperty('max-height', 'none', 'important');
                
                // Adjust textarea inside the box
                const textarea = box.querySelector('textarea');
                if (textarea) {
                  textarea.style.setProperty('height', 'auto', 'important');
                  textarea.style.setProperty('min-height', 'auto', 'important');
                  textarea.style.setProperty('max-height', 'none', 'important');
                  const scrollHeight = textarea.scrollHeight || textarea.clientHeight || 0;
                  if (scrollHeight > 0) {
                    textarea.style.setProperty('height', scrollHeight + 'px', 'important');
                  }
                }
                
                // Set box height to match content
                const boxHeight = box.scrollHeight || box.offsetHeight || 0;
                if (boxHeight > 0) {
                  box.style.setProperty('height', boxHeight + 'px', 'important');
                  box.style.setProperty('min-height', boxHeight + 'px', 'important');
                }
              }
            });
            
            // Fix Conclusion section - add 100px space below header for 3rd page print
            const conclusionSections = printWindow.document.querySelectorAll('.conclusion');
            conclusionSections.forEach((conclusion: any) => {
              if (conclusion) {
                // Add 100px padding-top to ensure content starts below header on new pages (3rd page)
                conclusion.style.setProperty('margin-top', '0', 'important');
                conclusion.style.setProperty('padding-top', '100px', 'important');
                conclusion.style.setProperty('page-break-before', 'auto', 'important');
                conclusion.style.setProperty('break-before', 'auto', 'important');
                
                // Fix conclusion card
                const conclusionCard = conclusion.querySelector('.card');
                if (conclusionCard) {
                  conclusionCard.style.setProperty('margin-top', '0', 'important');
                  conclusionCard.style.setProperty('padding-top', '0', 'important');
                }
                
                // Fix conclusion-infotext
                const conclusionInfo = conclusion.querySelector('.conclusion-infotext');
                if (conclusionInfo) {
                  conclusionInfo.style.setProperty('margin-top', '0', 'important');
                  conclusionInfo.style.setProperty('padding-top', '0', 'important');
                }
              }
            });
            
            // Adjust Coach Suggestions for AD Improvement boxes (.continue-development .whiteBox) to show full data
            const coachSuggestionBoxes = printWindow.document.querySelectorAll('.continue-development .whiteBox');
            coachSuggestionBoxes.forEach((box: any) => {
              if (box) {
                // Reset box height
                box.style.setProperty('height', 'auto', 'important');
                box.style.setProperty('min-height', 'auto', 'important');
                box.style.setProperty('max-height', 'none', 'important');
                box.style.setProperty('overflow', 'visible', 'important');
                
                // Adjust textarea inside the box
                const textarea = box.querySelector('textarea');
                if (textarea) {
                  // Remove all constraints
                  textarea.style.setProperty('height', 'auto', 'important');
                  textarea.style.setProperty('min-height', 'auto', 'important');
                  textarea.style.setProperty('max-height', 'none', 'important');
                  textarea.style.setProperty('overflow', 'visible', 'important');
                  textarea.style.setProperty('overflow-y', 'visible', 'important');
                  textarea.style.setProperty('overflow-x', 'visible', 'important');
                  
                  // Force reflow to get accurate scrollHeight
                  if (textarea.offsetHeight) {
                    // Reflow triggered
                  }
                  
                  // Set height to actual content height
                  const scrollHeight = textarea.scrollHeight || textarea.clientHeight || 0;
                  if (scrollHeight > 0) {
                    textarea.style.setProperty('height', scrollHeight + 'px', 'important');
                  }
                }
                
                // Let box height grow with content (avoid cutting off text on print)
                box.style.setProperty('height', 'auto', 'important');
                box.style.setProperty('min-height', 'auto', 'important');
                if (box.offsetHeight) {
                  // Reflow triggered
                }
                const boxHeight = box.scrollHeight || box.offsetHeight || 0;
                if (boxHeight > 0) {
                  // Keep auto so content is never cut off; optional: box.style.setProperty('min-height', boxHeight + 'px', 'important');
                  box.style.setProperty('max-height', 'none', 'important');
                  box.style.setProperty('overflow', 'visible', 'important');
                }
              }
            });

            // Remove trailing page breaks so no extra blank page is shown
            const wrapper = printWindow.document.querySelector('.print-content-wrapper');
            if (wrapper) {
              let last = wrapper.lastElementChild;
              while (last && (
                (last.classList && last.classList.contains('page-break')) ||
                (last instanceof HTMLElement && (last.style.pageBreakAfter === 'always' || last.style.breakAfter === 'page'))
              )) {
                last.remove();
                last = wrapper.lastElementChild;
              }
              // Force last element to not add a page break after (overrides any CSS class)
              if (last && last instanceof HTMLElement) {
                last.style.setProperty('page-break-after', 'auto', 'important');
                last.style.setProperty('break-after', 'auto', 'important');
              }
            }

            // Hide sections that have a header but no text content after the header (no extra page for header-only)
            const hideEmptySections = (doc: Document) => {
              const textOutside = (container: Element, exclude: Element): string => {
                let s = '';
                const walk = (node: Node) => {
                  if (node === exclude || (exclude.contains && exclude.contains(node))) {
                    return;
                  }
                  if (node.nodeType === Node.TEXT_NODE) {
                    s += (node.textContent || '');
                  }
                  node.childNodes.forEach(walk);
                };
                walk(container);
                return s.trim();
              };
              doc.querySelectorAll('.main-summary .card, .summry-bottom .card, .continue-development .card, .conclusion .card').forEach((card: Element) => {
                const c = card as HTMLElement;
                const header = c.querySelector('h4, h5, h6, .tc-header');
                if (!header) {
                  return;
                }
                if (!textOutside(c, header)) {
                  c.style.setProperty('display', 'none', 'important');
                }
              });
            };
            hideEmptySections(printWindow.document);
          };
          
          // Run multiple times to ensure Resources for Growth textareas are properly adjusted
          setTimeout(adjustPrintTextareas, 100);
          setTimeout(adjustPrintTextareas, 200);
          setTimeout(adjustPrintTextareas, 300);
          setTimeout(adjustPrintTextareas, 500);
          setTimeout(adjustPrintTextareas, 800);
          setTimeout(adjustPrintTextareas, 1000);

          // Wait longer so layout is ready on all platforms (Windows/Mac/Linux) before print
          setTimeout(() => {
            adjustPrintTextareas();
            setTimeout(() => {
              adjustPrintTextareas();
              setTimeout(() => {
                printWindow.print();
                printWindow.close();
              }, 300);
            }, 100);
          }, 1200);
        }
      }

      // Dynamically build editable report payload from state - ONLY editable fields
      private buildEditableReportPayload = (report: any, reportIdx: number) => {
        const reportKey = `report_${reportIdx}`;
        const formFieldData: any = this.state.formData?.[reportKey] || {};

        // Build payload with ONLY editable fields
        const editableReport: any = {
          id: report.id,
          type: "ad",
          audit_details: report.audit_details || {},
            key_strengths: report.key_strengths || [],
            improvement_opportunities: report.improvement_opportunities || [],
            team_connectedness: report.team_connectedness || {},
            suggestions_for_growth: report.suggestions_for_growth || {},
            sport_specific_insights: report.sport_specific_insights || {},
            grit_leadership_action_plan: report.grit_leadership_action_plan || {},
            conclusion: report.conclusion || {},

        };

        // Overall Summary
        if (formFieldData.overall_summary !== undefined) {
          editableReport.overall_summary = {
            summary: formFieldData.overall_summary || "",
          };
        }

        // Highlights and Strengths - array of {title, description}
        if (Array.isArray(formFieldData.highlights) && Array.isArray(report.highlights_and_strengths)) {
          editableReport.highlights_and_strengths = report.highlights_and_strengths.map(
            (item: any, idx: number) => ({
              title: item.title || "",
              description: formFieldData.highlights[idx] || item.description || "",
            })
          );
        }


          if (Array.isArray(formFieldData.parentFeedback) && Array.isArray(report.parent_feedback_summary)) {
          editableReport.parent_feedback_summary = report.parent_feedback_summary.map(
            (item: any, idx: number) => ({
              title: item.title || "",
              description: formFieldData.parentFeedback[idx] ||  item.description || "",
            })
          );
        }

        // Continuing Development - array of {title, description, explanation}
        if (Array.isArray(formFieldData.continuingDev) && Array.isArray(report.continuing_development)) {
          editableReport.continuing_development = report.continuing_development.map(
            (item: any, idx: number) => ({
              title: item.title || "",
              description: item.description || "",
              explanation: formFieldData.continuingDev[idx] || item.explanation || "",
            })
          );
        }

        // Coach Suggestions for AD Improvement
        if (formFieldData.coachSuggestionsAD !== undefined) {
          if (!editableReport.coach_suggestions_for_ad) {
            editableReport.coach_suggestions_for_ad = formFieldData.coachSuggestionsAD 
          }
        }

        // Resources for Growth - array of {resource_name, description}
        if (Array.isArray(formFieldData.resources) && Array.isArray(report.resources_for_growth)) {
          editableReport.resources_for_growth = report.resources_for_growth.map(
            (item: any, idx: number) => ({
              resource_name: item.resource_name || "",
              description: formFieldData.resources[idx] || item.description || "",
            })
          );
        }

        // Grit Leadership Action Plan - three separate fields
        // const gritPlanFromForm: any = {};
        // if (formFieldData.grit_mid_season_actions !== undefined) {
        //   gritPlanFromForm.mid_season_actions = formFieldData.grit_mid_season_actions || "";
        // }
        // if (formFieldData.grit_post_season_actions !== undefined) {
        //   gritPlanFromForm.post_season_actions = formFieldData.grit_post_season_actions || "";
        // }
        // if (formFieldData.grit_season_end_reviews !== undefined) {
        //   gritPlanFromForm.season_end_reviews = formFieldData.grit_season_end_reviews || "";
        // }
        // // Merge with existing report value (keep other keys intact)
        // editableReport.grit_leadership_action_plan = {
        //   ...(report.grit_leadership_action_plan || {}),
        //   ...gritPlanFromForm,
        // };

       

        console.log("Editable Report Payload:", editableReport);
        return editableReport;
      }
      // Initialize form data from report
      private initializeFormData = () => {
        const { editableReportData } = this.state;
        console.log("Initializing form data from editableReportData:", editableReportData);
        if (!editableReportData || editableReportData.length === 0) {
          return;
        }

        const formData: Record<string, any> = {};

        editableReportData.forEach((report: any, reportIdx: number) => {
          const reportKey = `report_${reportIdx}`;
          
          formData[reportKey] = {
            overall_summary: report.overall_summary?.summary ?? "",
            parentFeedback_appreciate: report.parent_feedback_summary?.parents_appreciate ?? "",
            parentFeedback_suggestions: report.parent_feedback_summary?.suggestions_for_growth ?? "",
            coachSuggestions_0: report.coach_suggestions_for_ad?.[0]?.summary ?? "",
            coachSuggestions_1: report.coach_suggestions_for_ad?.[1]?.summary ?? "",
            team_connectedness_intro: Array.isArray(report.team_connectedness?.intro) 
              ? report.team_connectedness.intro.join(" ") 
              : report.team_connectedness?.intro ?? "",
            coachSuggestionsAD: report.coach_suggestions_for_ad,
            chatgptChanges: report.chatgptChangeResposne || {},
            highlights: (report.highlights_and_strengths || []).map((h: any) => {
              const description = h.description || "";
              const quotes = Array.isArray(h.quotes) && h.quotes.length > 0
                ? `\n"${h.quotes.map((q: any) => `${q}`).join("\n")}"`
                : "";
              return `${description}${quotes}`.trim();
            }),
            parentFeedback: (report.parent_feedback || []).map((d: any) => d.description || ""),
            continuingDev: (report.continuing_development || []).map((d: any) => {
              const explanation = d.explanation || "";
              const quotes = Array.isArray(d.quotes) && d.quotes.length > 0
                ? `\n"${d.quotes.map((q: any) => `${q}`).join("\n")}"`
                : "";
              return `${explanation}${quotes}`.trim();
            }),
            resources: (report.resources_for_growth || []).map((r: any) => r.description || ""),
            // Grit Leadership Action Plan separate fields
            grit_mid_season_actions: typeof report.grit_leadership_action_plan?.mid_season_actions === 'string'
              ? report.grit_leadership_action_plan.mid_season_actions
              : (report.grit_leadership_action_plan?.mid_season_actions ?? ""),
            grit_post_season_actions: typeof report.grit_leadership_action_plan?.post_season_actions === 'string'
              ? report.grit_leadership_action_plan.post_season_actions
              : (report.grit_leadership_action_plan?.post_season_actions ?? ""),
            grit_season_end_reviews: typeof report.grit_leadership_action_plan?.season_end_reviews === 'string'
              ? report.grit_leadership_action_plan.season_end_reviews
              : (report.grit_leadership_action_plan?.season_end_reviews ?? ""),
          };
        });

        this.setState({ formData });
      }
      private renderEmailModal() {
        const { emailModalOpen, emailValue, emailSending, emailError, emailSuccess } = this.state as any;
        return (
          <Dialog open={!!emailModalOpen} onClose={this.handleCloseEmailModal}>
            <DialogTitle>Send Report on Email</DialogTitle>
            <DialogContent>
              <TextField
                label="Recipient Email"
                type="email"
                value={emailValue || ""}
                onChange={this.handleEmailChange}
                fullWidth={true}
                autoFocus={true}
                disabled={emailSending}
                margin="dense"
              />
              {emailError && <div style={{ color: "red", marginTop: 8 }}>{emailError}</div>}
              {emailSuccess && <div style={{ color: "green", marginTop: 8 }}>{emailSuccess}</div>}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseEmailModal} color="secondary" disabled={emailSending}>
                Cancel
              </Button>
              <Button onClick={this.handleSendEmail} color="primary" disabled={emailSending}>
                {emailSending ? "Sending..." : "Send"}
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      private renderEditableReportData() {
        const { editableReportData, confirmGenerateReportOpen } = this.state as any;
        const isReadOnly = true; // Force read-only mode for report view
        console.log("renderEditableReportData - editableReportData:", editableReportData);
        console.log("editableReportData length:", editableReportData?.length);

        // Open confirmation popup
        const handleOpenConfirmPopup = () => {
          this.setState({ confirmGenerateReportOpen: true });
        };

        // Close popup without action
        const handleCloseConfirmPopup = () => {
          this.setState({ confirmGenerateReportOpen: false });
        };

        // Confirm and run GenerateReport
        const handleConfirmGenerateReport = () => {
          this.setState({ confirmGenerateReportOpen: false }, () => {
            this.GenerateReport();
          });
        };
        // Button ko hamesha return karo
        const generateReportButton = (
          <>
            <Button
              type="button"
              variant="contained"
              color="primary"
              style={{
                margin: "24px 0",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }}
              onClick={handleOpenConfirmPopup} // Confirmation first
            >
              Generate Report
            </Button>

            {/* Confirmation Popup */}
            <Dialog
              open={confirmGenerateReportOpen}
              onClose={handleCloseConfirmPopup}
            >
              <DialogTitle>Confirm Report Generation</DialogTitle>
              <DialogContent>
                Are you sure all your data is recorded? You can only generate this summary report once.
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseConfirmPopup} color="secondary">
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirmGenerateReport}
                  color="primary"
                  variant="contained"
                >
                  Yes, Generate
                </Button>
              </DialogActions>
            </Dialog>
          </>
        );



        if (!editableReportData || !Array.isArray(editableReportData) || editableReportData.length === 0) {
          return (
            <div style={{ textAlign: "center", color: "#888", margin: "40px 0", fontSize: 20 }}>
              {generateReportButton}
              {this.state.showLoader ? (
                <div style={{ marginTop: 24 }}>
                  {/* <CircularProgress /> */}
                </div>
              ) : (
                <div style={{ marginTop: 24, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}> <ArrowUpwardIcon />  Click on Generate Report to create your report.  {/* No Report found */} </div>

              )}
            </div>
          );
        }
        return (
          <div>
            {this.props.schoolData.ismidseason === false && (
              <h1 style={{ textAlign: "center", marginBottom: 32 }}>
                Reports
              </h1>
            )}
            {generateReportButton}


            {editableReportData?.slice(0, 1).map((report: any, reportIdx: number) => {

              const auditDetails = report.audit_details || {};
              const prevSummary = auditDetails.previous_year_summary || {};

              const studentChange = getPercentChange(
                auditDetails.total_students_surveyed,
                prevSummary.total_students_surveyed
              );
              const parentChange = getPercentChange(
                auditDetails.total_parents_surveyed,
                prevSummary.total_parents_surveyed
              );
              const coachChange = getPercentChange(
                auditDetails.total_coaches_surveyed,
                prevSummary.total_coaches_surveyed
              );

              const seasonLabel =
                (auditDetails.season || report.sessionType || "").toString().toUpperCase();

              const keyStrengths: string[] = Array.isArray(report.key_strengths)
                ? report.key_strengths
                : [];
              const improvementOpps: string[] = Array.isArray(report.improvement_opportunities)
                ? report.improvement_opportunities
                : [];

              const highlights: any[] = Array.isArray(report.highlights_and_strengths)
                ? report.highlights_and_strengths
                : [];

             let parentFeedback = report.parent_feedback_summary || [];
             
             // Mark items with title "Supporting Comments" as read-only
             if (Array.isArray(parentFeedback) && parentFeedback.length > 0) {
               parentFeedback = parentFeedback.map((item: any) => ({
                 ...item,
                 isReadOnly: item.title === "Supporting Comments"
               }));
             }

              const continuingDev: any[] = Array.isArray(report.continuing_development)
                ? report.continuing_development
                : [];

              // const coachSuggestions: any[] = Array.isArray(report.coach_suggestions_for_ad)
              //   ? report.coach_suggestions_for_ad
              //   : [];

              const resourcesForGrowth: any[] = Array.isArray(report.resources_for_growth)
                ? report.resources_for_growth
                : [];

              const gritPlan = report.grit_leadership_action_plan || {};

              const teamConnectedness = report.team_connectedness || {};

              const schoolName = this.props?.schoolData?.name || this.props.schoolData?.schoolName;
              const schoolLogo = this.props?.schoolData?.logo1;
              const conclusionInfoText = report.conclusion?.message || "";

              const strengthIcons = ["far fa-smile", "fas fa-heart", "fas fa-comments"];

              return (
                <form
                key={report.id}
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (isReadOnly) { return; }
                  try {
                    // Build editable report payload dynamically from state
                    const editableReport = this.buildEditableReportPayload(report, reportIdx);

                    console.log("Editable Report being sent:", editableReport);

                    const UpdateReportData = await this.buildPost<any, any>(
                      this, "/reports/reportUpdate"
                    )([editableReport]);
                   console.log("Report updated successfully:", UpdateReportData);
                    alert("Report updated successfully!");
                    this.props.refreshReports();

                  } catch (error) {
                    console.error("Error in ReportData", error);
                  }
                }}
                  style={{

                    background: "#f9f9f9",

                  }}
                >
                <div style={{ display: "flex", flexDirection: "column", gap: "15px", justifyContent: "space-between" }}>

                  {/* <div className="title-container 1111111111111" style={{ display: "flex", justifyContent: "space-between" }}>
                    <h3>{schoolName}</h3>
                    {schoolLogo && (
                      <img src={schoolLogo} alt="School Logo" style={{ width: 50, height: 50 }} />
                    )}
                  </div> */}

                  <div className="date-print-button " style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ color: "#000", fontWeight: "bold", fontSize: "12px", display: "flex", justifyContent: "start", gap: "25px" }}>
                      <div>
                        {auditDetails.report_date
                          ? format(new Date(auditDetails.report_date), "MMMM D, YYYY")
                          : format(report.date, "MMMM D, YYYY")}
                      </div>
                      <div> {seasonLabel}</div>
                      {/* <div style={{ fontWeight: 500, color: "#555" }}> {this.props?.coach.name} </div> 
                      <div style={{ fontWeight: 500, color: "#555" }}>{this.props?.sport.name} </div>  */}

                    </div>
                    <div>


                      <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        style={{ marginRight: "10px" }}
                        onClick={() => this.handlePrint(report)}
                      >
                        Print
                      </Button>
                      {/* <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: 0, float: "right" }}
                      >
                        Update
                      </Button> */}




                    </div>
                  </div>
                </div>
                <div style={{ borderTop: "1px solid #eee", margin: "10px 0px" }} />
              
                
              <div id="reprotNewContainer">
                <div className="top-section">
                  <div className="report-header">
                    <div className="header-left">
                      <p className="subtitle">Athletic Program Snapshot - {seasonLabel}</p> 
                      <h1 className="title">{schoolName}</h1>
                    </div>

                    <div className="header-right">
                      {schoolLogo && (
                        <img src={schoolLogo} alt="School Logo" style={{ width: "50px", height: "50px" }} />
                      )}
                    </div>
                  </div>
                  <div className="three-points-container">
                    <div className="surveyed-score">
                      <div className="stat">
                        <strong>{auditDetails.total_students_surveyed ?? "-"}</strong>
                        <span>students surveyed</span>
                        <p>
                          <small className={getPercentClass(studentChange)}>
                            {formatPercent(studentChange)}
                          </small>{" "}
                          from {prevSummary.year ?? ""}
                        </p>
                      </div>

                      <div className="stat">
                        <strong>{auditDetails.total_parents_surveyed ?? "-"}</strong>
                        <span>parents surveyed </span>
                        <p>
                          <small className={getPercentClass(parentChange)}>
                            {formatPercent(parentChange)}
                          </small>{" "}
                          from {prevSummary.year ?? ""}{" "}
                        </p>
                      </div>

                      <div className="stat">
                        <strong>{auditDetails.total_coaches_surveyed ?? "-"}</strong>
                        <span>coach responses</span>
                        <p>
                          <small className={getPercentClass(coachChange)}>
                            {formatPercent(coachChange)}
                          </small>{" "}
                          from {prevSummary.year ?? ""}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="report-card">
                      <div className="report-date">
                        <span className="label">report date</span>
                        <strong>
                              {auditDetails?.report_date
                                ? format(new Date(auditDetails.report_date), "MMMM D, YYYY")
                                : ""}
                        </strong>
                      </div>
                      <div className="season">{seasonLabel}</div>
                    </div>
                  </div>


                  <div className="three-points-container">
                    <div className="three-points">
                      <h6>Key Strengths</h6>
                      <div className="pill-row">
                        {keyStrengths.map((item) => (
                          <span key={item} className="pill">
                            {String(item).toUpperCase()}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="three-points">
                      <h6>Improvement Opportunities </h6>
                      <div className="pill-row">
                        {improvementOpps.map((item) => (
                          <span key={item} className="pill">
                            {String(item).toUpperCase()}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="main-summary">
                  <div className="card pad">
                    <h5>Highlights and Strengths</h5>
                    <div className="list">
                      {highlights.map((item, idx) => {
                        const description = item.description ?? "";
                        const quotes = Array.isArray(item.quotes) && item.quotes.length > 0
                          ? `\n"${item.quotes.map((q: any) => `${q}`).join("\n")}"`
                          : "";
                        const combinedText = `${description}${quotes}`.trim();
                        return (
                          <div key={idx} className="item">
                            <div className="icon">
                              <i className={strengthIcons[idx] || "far fa-smile"} />
                            </div>
                            <div>
                              <h4>{item.title}:</h4>
                              <p
                                style={{
                                  width: "100%",
                                  margin: 0,
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                }}
                              >
                                {this.state.formData?.[`report_${reportIdx}`]?.highlights?.[idx] ?? combinedText}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="card pad summary">
                    <h5>Summary</h5>
                    <p
                      style={{
                        width: "100%",
                        background: "transparent",
                        border: "none",
                        boxSizing: "border-box",
                        fontFamily: "'Lato', sans-serif",
                        whiteSpace: "pre-wrap",
                        minHeight: "60px",
                        margin: 0
                      }}
                    >
                      {this.state.formData?.[`report_${reportIdx}`]?.overall_summary ?? ""}
                    </p>
                  </div>
                </div>

                <div className="summry-bottom">
                  <div className="card pad">
                    <h5>Parent Feedback Summary</h5>
                   
                     {parentFeedback.map((item:any, idx:any) => {
                       // Check if this is the read-only item (Supporting Comments - 3rd item)
                       
                       const isItemReadOnly = item.isReadOnly === true;
                       
                       if (isItemReadOnly) {
                         const description = item.description ?? "";
                         const quote = item.quote ? `\n"${item.quote}"` : "";
                         const combinedText = `${description}${quote}`.trim().replace(/\n\s*\n/g, "\n");
                         
                         return (
                           <div key={idx} className="whiteBox pad">
                             <h4>{item.title}</h4>
                             <p style={{ 
                               whiteSpace: "pre-wrap", 
                               wordWrap: "break-word",
                            
                             }}>
                               {combinedText}
                             </p>
                           </div>
                         );
                       }
                       
                       const description = this.state.formData?.[`report_${reportIdx}`]?.parentFeedback?.[idx] ?? item.description ?? "";
                       const quote = item.quote ? `\n"${item.quote}"` : "";
                       const combinedText = `${description}${quote}`.trim();
                       
                       return (
                        <div key={idx} className="whiteBox pad">
                          <h4>{item.title}</h4>
                          <p
                            style={{
                              width: "100%",
                              border: "none",
                              boxSizing: "border-box",
                              whiteSpace: "pre-wrap",
                              minHeight: "60px",
                              margin: 0,
                              wordBreak: "break-word"
                            }}
                          >
                            {combinedText}
                         </p>
                        </div>
                      );
                     
                     })}
                      
                  

                  </div>

                  <div className="card pad">
                   
                    <div className="connectedness">
                    <div className="tc-header">
                      <h5>Team Connectedness</h5>
                      <span>Scored out of 10.0</span>
                    </div>
                    <div className="scores">
                      {teamConnectedness?.markers.map((item:any, idx:any) => {
                       const scoreValue = (item.score != null && item.score !== '' && !isNaN(Number(item.score))) ? Number(item.score) : 0;
                       const roundedScore = Math.round(scoreValue * 10) / 10;
                       const deg = Math.min(360, Math.max(0, (scoreValue / 10) * 360));
                       const staticLabel = DEFAULT_TEAM_CONNECTEDNESS_SCORES[idx]?.label || item.label || '';
                        return (
                        <div key={idx} className="score">
                          <div
                            className="ring"
                            style={{
                              background: `conic-gradient(from 90deg, #0b3a6f 0deg ${deg}deg, #e6edf4 ${deg}deg 360deg)`,
                            }}
                          >
                            <span>{roundedScore.toFixed(1)}</span> 
                          </div>
                          <p>{staticLabel}</p>
                        </div>
                      );})}
                    </div>
                  </div>
                    <div className="overallOuter">
                      <div className="overallInfo">
                       <p>Connectedness and belonging are key drivers of individual and team performance. Research shows that when athletes feel connected—to teammates and coaches—they develop a stronger sense of belonging and invest more in the team, school, and community. Highly connected programs consistently perform at higher levels on and off the field. To strengthen Connectedness scores, we recommend reviewing the Resources for Growth section and incorporating Grit Leadership mid-season check-ins to gather real-time data and make timely adjustments during your season.</p>
                    
                      </div>
                      <div className="overall">
                                                <span> Averaged from 3 questions with data</span>
                        {/* <span>
                          <small>{teamConnectedness.overall_change ?? ""}</small>{" "}
                          {teamConnectedness.overall_change && "from previous season"}
                        </span> */}
                        <strong>
                          {teamConnectedness.overall_score != null && !isNaN(Number(teamConnectedness.overall_score))
                            ? (Math.round(Number(teamConnectedness.overall_score) * 10) / 10).toFixed(1)
                            : "-"}
                        </strong>
                        <p>Overall Team Connectedness Score </p>
                      </div>
                    </div>
                  </div>
                </div>


                 <div className="continue-development">
                  <div className="card pad">
                    <h5>Continuing Development</h5>
                    <div className="list">
                      {continuingDev.map((item, idx) => {
                        const explanation = item.explanation ?? "";
                        const quotes = Array.isArray(item.quotes) && item.quotes.length > 0
                          ? `\n"${item.quotes.map((q: any) => `${q}`).join("\n")}"`
                          : "";
                          
                        const combinedText = `${explanation}${quotes}`.trim();
                        return (
                        <div key={idx} className="item">
                          <div className="icon">
                            <i
                              className={
                                idx === 0
                                  ? "fas fa-bullhorn"
                                  : idx === 1
                                  ? "far fa-lightbulb"
                                  : "far fa-user"
                              }
                            />
                          </div>
                          <div>
                            <h4>
                              {item.title}: {item.description}
                            </h4>
                            <p
                              style={{
                                width: "100%",
                                border: "none",
                                boxSizing: "border-box",
                                whiteSpace: "pre-wrap",
                                minHeight: "60px",
                                margin: 0,
                                wordBreak: "break-word"
                              }}
                            >
                              {this.state.formData?.[`report_${reportIdx}`]?.continuingDev?.[idx] ?? combinedText}
                            </p>
                          </div>
                        </div>
                      )})}
                    </div>

                    <div className="whiteBox pad coachsuggestion">
                       <h6>Coach Suggestions for AD Improvement</h6>
                      {/* {(() => {
                        const coachSuggestions = Array.isArray(report.coach_suggestions_for_ad) ? report.coach_suggestions_for_ad : [];
                        const combinedText = coachSuggestions.map((item: any) => {
                         // const theme = item.theme ? `${item.theme}: ` : "";
                          const summary = item.summary ?? "";
                          const quotes = Array.isArray(item.quotes) && item.quotes.length > 0
                            ? "\n\nQuotes:\n" + item.quotes.map((q: any) => `"${q}"`).join("\n")
                            : "";
                          return `${summary}${quotes}`.trim();
                        }).join("\n\n");
                        return ( */}
                          <p
                            style={{
                              width: "100%",
                              border: "none",
                              boxSizing: "border-box",
                              whiteSpace: "pre-wrap",
                              minHeight: "60px",
                              margin: 0,
                              wordBreak: "break-word"
                            }}
                          >
                            {(this.state.formData?.[`report_${reportIdx}`]?.coachSuggestionsAD ?? report.coach_suggestions_for_ad)?.replace(/\n\s*\n/g, "\n")}
                          </p>
                        {/* );
                      // })()} */}
                    </div>


                  </div>
                  <div className="card pad">
                  <div className="resources-for-growth-heading-wrap" style={{ marginBottom: 0 }}>
                  <h5 style={{ margin: 0, padding: 0 }}>Resources for Growth</h5>
                  </div>
                    <div className="resource-container" style={{ marginTop: 0 }}>
                      {resourcesForGrowth.map((item, idx) => {
                          let paragraphText = this.state.formData?.[`report_${reportIdx}`]?.resources?.[idx] ?? item.description ?? "";
                          if (typeof paragraphText === "string") {
                            const otherTitles = resourcesForGrowth
                              .map((r: any) => (r.resource_name || "").trim())
                              .filter((t: string) => t && t !== (item.resource_name || "").trim());
                            const otherTitlesSet = new Set(otherTitles);
                            const normalize = (s: string) => s.replace(/\*+/g, "").trim();
                            let lines = paragraphText.split(/\r?\n/);
                            lines = lines.filter((line: string) => !otherTitlesSet.has(normalize(line)));
                            paragraphText = lines
                              .map((line: string) => {
                                let cleaned = line;
                                otherTitles.forEach((title: string) => {
                                  cleaned = cleaned.replace(new RegExp(`\\*\\*${title.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\*\\*`, "g"), "");
                                });
                                return cleaned.trim();
                              })
                              .join("\n")
                              .trim();
                          }
                          return (
                        <div key={idx} className="whiteBox pad resources-growth-box">
                         <div className="printclass"> 
                          <p className="title-para" style={{ fontWeight: "bold",marginBottom: "10px",fontSize: "18px", textAlign: "center", fontStyle: "normal"}}>{item.resource_name}</p>
                          <p
                            style={{
                              width: "100%",
                              border: "none",
                              boxSizing: "border-box",
                              whiteSpace: "pre-wrap",
                              minHeight: "60px",
                              margin: 0,
                              wordBreak: "break-word"
                            }}
                          >
                             
                            {paragraphText}
                         </p></div>
                       </div>
                          );
                      })}
                    </div>
                  
                  </div>
                </div>

                <div className="conclusion">
            
                 <div className="card pad">

                  <h5>Conclusions </h5>

                  <div className="whiteBox pad">
                   
                    <div className="action-plan-wrapper">
                       <h5> Grit Leadership Action Plan </h5>
                        <div className="timeline">
                         {gritPlan.mid_season_actions !== undefined && (
                              <div className="step">
                                <div className="smallcard">
                                
                                <div style={{fontStyle: "italic", width: "100%", border: "none", boxSizing: "border-box", background: "transparent", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                                  {this.state.formData?.[`report_${reportIdx}`]?.grit_mid_season_actions ?? (typeof gritPlan.mid_season_actions === 'string' ? gritPlan.mid_season_actions : '')}
                                </div>
                                </div>
                                <span className="dot">&nbsp;</span>
                                <span className="label">mid-season</span>
                              </div>
                            )}

                          {gritPlan.post_season_actions !== undefined && (
                              <div className="step">
                                <div className="smallcard">
                          
                                <div style={{fontStyle: "italic",textAlign: "left", width: "100%", border: "none", boxSizing: "border-box", background: "transparent", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                                  {this.state.formData?.[`report_${reportIdx}`]?.grit_post_season_actions ?? (typeof gritPlan.post_season_actions === 'string' ? gritPlan.post_season_actions : '')}
                                </div>
                                </div>
                                <span className="dot">&nbsp;</span>
                                <span className="label">post-season</span>
                              </div>
                            )}

                          {gritPlan.season_end_reviews !== undefined && (
                              <div className="step">
                                <div className="smallcard">
                                
                                <div style={{fontStyle: "italic",textAlign: "left", width: "100%", border: "none", boxSizing: "border-box", background: "transparent", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                                  {this.state.formData?.[`report_${reportIdx}`]?.grit_season_end_reviews ?? (typeof gritPlan.season_end_reviews === 'string' ? gritPlan.season_end_reviews : '')}
                                </div>
                                </div>
                                <span className="dot">&nbsp;</span>
                                <span className="label">season-end</span>
                              </div>
                            )}
                        </div>
                      </div>

                  </div>

                   <div className="conclusion-infotext">
                    <h5> A Note From Our Founder </h5>
                    <p>
                      {conclusionInfoText}
                      
                    </p>
                    <h5> Kevin Broene</h5>
                  </div>               
                </div>
              </div>
            </div>
                {Object.keys(report.chatgptChangeResposne).map((key) => {

                  const original = report.chatgptChangeResposne[key] || '';
                  const value = String(original);

                  let contentBody = null;

                  // Special rendering for "Team Connectedness:"
                  if (key.trim().toLowerCase().includes("team connectedness")) {
                    contentBody = (
                      <div className="team-connectedness-section" style={{ marginBottom: 20 }}>
                        <pre style={{ scrollbarColor: "none", all: "unset", margin: "0", whiteSpace: "normal" }}>
                          <span className="textarea-fontFamily"
                            dangerouslySetInnerHTML={{
                              __html: value.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>").replace(/\*(.*?)\*/g, "<b>$1</b>")
                            }}
                          />
                        </pre>
                      </div>
                    );
                  } else {

                    contentBody = (

                      <div
                        className="editable-div textarea-fontFamily"
                        style={{
                          width: "100%",
                          minHeight: 80,
                          fontSize: 13,
                          padding: 10,
                          borderRadius: 4,
                          border: "1px solid #bbb",
                          background: "#f1f1f1",
                          lineHeight: "17px",
                          whiteSpace: "pre-wrap"
                        }}
                        dangerouslySetInnerHTML={{
                          __html: cleanAndFormatHtml_New(typeof value === "string" ? value : "")
                        }}
                      />
                    )
                  }

                  return (
                    <div key={key} style={{ marginBottom: 14 }}>
                      <label
                        className="title-fontFamily"
                        style={{
                          fontWeight: "400",
                          fontSize: 17,
                          display: "block",
                          marginTop: 15,
                          marginBottom: 6,
                          color: "white",
                          padding: "0px 8px",
                          borderTop: "2px solid #000",
                          borderBottom: "2px solid #000",
                          backgroundColor: this.props.schoolData?.primaryColor
                        }}
                      >
                        {key}
                      </label>

                      {contentBody}

                    </div>

                  );
                })}
                <div style={{ paddingBottom: "15px", marginBottom: "15px" }}>
                  {/* <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "0px", float: "right", marginBottom: "15px" }}
                  >
                    Update
                  </Button> */}
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    style={{ marginRight: "10px", float: "right", marginBottom: "15px" }}
                    onClick={() => this.handlePrint(report)}
                  >
                    Print
                  </Button>
                </div>
                <style>
                  {`
                      .team-connectedness-section p,
                      .team-connectedness-section table td,
                      .team-connectedness-section table th,
                      .textarea-fontFamily, .textarea-fontFamily * {
                          font-family: Open Sans, sans-serif !important;	
                       
                        }
                        .team-connectedness-section table td,
                        .team-connectedness-section table th {
                          padding: 5px 10px !important;
                        }
                      .team-connectedness-section p {
                        font-weight:bold;
                      } 
                        .team-connectedness-section table thead th {
                          white-space:nowrap;
                        }
                        .team-connectedness-section b,          
                      .team-connectedness-section p,
                      .team-connectedness-section table td,
                      .team-connectedness-section table th {
                        font-size:13px;
                        color:#000;
                      }
                      .title-heading {
                        font-family: "Russo One", Arial, sans-serif !important;
                        font-size: 24px;
                        margin-bottom: 3px;
                      }
                        .title-fontFamily {
                        font-family: Russo One, Arial, sans-serif !important;
                        }
                        
                       @media print {
                            .footer-logo {
                                  position: fixed !important;
                                  bottom: 10px !important;
                                  width: 100%;
                                  text-align: center;
                                  left: 0%;
                                  transform: translateX(50%, 50%);
                                                  
                              }
                          
                              .footer-logo img {
                                  height: 27px !important;
                                  width: 27px!important;
                                  bottom: 0px !important;
                                      position: absolute !important;
                                  text-align: center;
                                  transform: translateX(50%, -50%);
                                  left: 48% !important;
                              }   
                                @page {
                                margin-bottom: 20mm; /* Prevent clipping at bottom */
                              }  
                               .title-fontFamily {
                                  font-family: Russo One, Arial, sans-serif !important;
                                  }                  
                          
                          }
              
                `}
                </style>
                <div id={`printable-report-${report.id}`} style={{ display: "none", position: "relative" }}>
                  <div style={{ border: "none", paddingBottom: 80 }}>

                    <div style={{ marginBottom: 20 }}>
                      <h2 className="title-fontFamily" style={{ textAlign: "left" }}>Annual Report</h2>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h3 className="title-fontFamily"> {this.props?.schoolData?.name} </h3>
                        <img src={this.props?.schoolData?.logo1} alt="School Logo" style={{ position: "relative", top: "-5px", width: 70, height: 70 }} />

                      </div>
                      {/* <strong style={{ fontWeight: 500, color: "#555" }}> Coach: {this.props?.coach.name} </strong> <br />
                      <strong style={{ fontWeight: 500, color: "#555" }}> Sport: {this.props?.sport.name} </strong> <br /> */}
                      <div style={{ display: "flex", justifyContent: "start", gap: "25px" }}>
                        <div className="title-fontFamily"> {format(report.date, "MMMM D, YYYY")}</div>
                        <div className="title-fontFamily"> {report.sessionType} </div>
                      </div>
                    </div>

                    {Object.keys(report.chatgptChangeResposne).map((key, index) => {
                      // const value = report.chatgptChangeResposne[key];
                      const original = report.chatgptChangeResposne[key] || '';
                      const value = String(original).includes('\n')
                        ? original
                        : String(original)


                      return (
                        <React.Fragment key={`${key}-${index}`}>
                          <div className="report-section" style={{ marginBottom: 25 }}>

                            {/* {titleContent} */}

                            <div className="titleColored" style={{
                              padding: "6px 10px", borderTop: " 2px solid #000", borderBottom: " 2px solid #000",
                              background: this.props.schoolData?.primaryColor, color: "#fff", fontWeight: "bold", fontSize: 16, marginBottom: 4
                            }}>
                              {key}:

                            </div>
                            <div style={{
                              background: "#f4f7fa",
                              borderRadius: 4,
                              padding: 12,
                              fontSize: 15,
                              color: "#222",
                              border: "1px solid #e0e0e0",
                              whiteSpace: "normal",

                            }}>

                              <style>
                                {`
                                  @media print {
                                    .textarea-fontFamily {
                                      font-family: 'Open Sans', sans-serif !important;
                                    }
                                  }
                                `}
                              </style>

                              <div id={`printable-report-${report.id}`}>
                                {/* Printable content here */}

                                <pre style={{ scrollbarColor: "none", all: "unset", margin: "0", whiteSpace: "normal" }} >
                                  <span className="textarea-fontFamily"
                                    style={{ fontSize: '13px' }}
                                    dangerouslySetInnerHTML={{
                                      __html: value
                                        .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
                                        .replace(/\*(.*?)\*/g, "<b>$1</b>")
                                    }}
                                  />
                                </pre>
                              </div>
                            </div>
                          </div>
                          {/* {(index + 1) % 4 === 0 && (
                              <div
                                className="page-break"
                                style={{ pageBreakAfter: "always", display: "block" }}
                              />
                            )} */}
                        </React.Fragment>
                      );
                    })}


                    {/* Fixed logo for print */}

                    <div
                      className="footer-logo"
                      style={{
                        position: 'fixed',
                        top: "auto",
                        bottom: '20px',
                        width: '100%',
                        textAlign: 'center',
                        zIndex: 10000
                      }}
                    >
                      <img
                        src={gritLogo}
                        alt="Grit Leadership Logo"
                        style={{ height: '30px', position: "absolute", bottom: "0px" }}
                      />
                    </div>

                  </div>
                </div>
              </form>
            ); })}
            {this.renderEmailModal()}
          </div>
        );
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/reportGeneratemodal.tsx